<template>

    <spinner-until :condition="!attesting">
        <div class="project-view-attestation">
            <b-card no-body>
                <b-card-header class="pod-heading">
                    <h5>Attestation Status</h5>
                    <div class="heading__buttons"/>
                </b-card-header>
                <b-card-body>
                    <template v-if="project.status === 'DRAFT' || project.status === 'ENTERED_BUT_NOT_ATTESTED'">
                        <template v-if="companyProject && !companyProject.attested">
                            <p><strong>Project requires your attestation before proceeding.</strong></p>
                            <p>You will need to complete the following prior to the project
                                beginning. Check your contract to ensure you meet required timelines.</p>
                            <ul>
                                <li>Register additional equipment or vehicles if needed</li>
                                <li>Ensure all subcontractors using covered equipment or vehicles at any tier below you are added to the project (if any)</li>
                                <li>Provide information for any rented equipment you will bring on the project</li>
                                <li>Attest to your understanding of the Clean Air Construction requirements on this project.</li>
                            </ul>
                            <hr/>
                            <b-btn @click="attestProject" variant="success" class="float-right">
                                Attest Project
                                <b-icon-bag-check/>
                            </b-btn>
                        </template>
                        <template v-else>
                            <p>Awaiting attestation from all contractors. If you've added subcontractors to the project,
                                please ensure that they attest.</p>
                        </template>
                    </template>
                    <template v-if="project.status === 'IN_PROGRESS'">
                        <p>Project has been attested by all contractors.</p>
                    </template>
                </b-card-body>
            </b-card>
        </div>
    </spinner-until>

</template>

<script>
import Vue from 'vue'

export default Vue.extend({
    name: 'ProjectViewAttestation',
    props: {
        project: Object,
    },
    data () {
        return {
            attesting: false,
            companyProject: null,
            companyId: null,
        }
    },
    methods: {
        // TODO: check permissions
        async attestProject () {
            const val = await this.$bvModal.msgBoxConfirm(

                'I hereby attest to confirm:' + "\n" +
                '        1. All subcontractors using covered equipment or vehicles at any tier below me are added to the project (if any).\n' +
                '        2. My equipment, whether owned or rented, and that of all hired subcontractors will remain in compliance for the duration of this project, or will have a valid exemption. \n' +
                '        3. My company and all hired subcontractors will abide by idle reduction requirements.\n' +
                '        4. I will provide timely updates of any changes regarding all of the above.', {
                    title: 'Attestation',
                    size: 'lg',
                    buttonSize: 'default',
                    okVariant: 'success',
                    okTitle: 'Attest',
                    cancelTitle: 'Cancel',
                    cancelVariant: 'danger',
                    footerClass: 'p-2',
                    hideHeaderClose: true,
                    centered: true
                })
            if (val) {
                this.attesting = true
                await this.$api.attestProject(this, this.project.id, this.companyId)
                window.location.reload()
            }
        }
    },
    created () {
        this.companyId = this.$user.getCompanyId()

        this.$api.getItem(this, 'project', this.project.id, ['companyProjects']).then((company) => {
            if (company.companyProjects) {
                this.companyProject = company.companyProjects.find((companyProject) => {
                    return companyProject.company_id === this.companyId
                })
            }
        })
    }
})
</script>